import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Skeleton } from '../../components/ui/skeleton';
import { Badge } from '../../components/ui/badge';
import { headlineExpAPI } from '../../lib/api';
import { FlaskConical } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function AdminHeadlineExperiments() {
  const [exps, setExps] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    headlineExpAPI
      .list()
      .then((r) => setExps(r.data?.experiments || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-4" data-testid="admin-ab-tests-page">
      <div>
        <h1 className="text-2xl font-bold flex items-center gap-2"><FlaskConical className="w-6 h-6 text-[#B89B5E]" /> Headline A/B Experiments</h1>
        <p className="text-sm text-[#5B616E] mt-1">Multi-variant headline testing with click-through-rate (CTR) tracking. Configure variants per article in the editor, then monitor here.</p>
      </div>

      {loading ? <Skeleton className="h-72 rounded-xl" /> : exps.length === 0 ? (
        <Card className="bg-white border-[#E7E0D6]"><CardContent className="py-16 text-center text-[#5B616E]">No experiments running yet.</CardContent></Card>
      ) : (
        <div className="space-y-3">
          {exps.map((exp) => {
            const variants = exp.variants || [];
            const winnerId = exp.winner_variant_id;
            const totalImps = variants.reduce((s, v) => s + (v.impressions || 0), 0);
            return (
              <Card key={exp.id} className="bg-white border-[#E7E0D6]">
                <CardHeader className="pb-2 flex flex-row items-center justify-between">
                  <CardTitle className="text-sm">
                    <Link to={`/admin/articles/${exp.article_id}/edit`} className="text-[#1E5A8A] underline">Article {exp.article_id.slice(0, 6)}…</Link>
                    <span className="ml-2 text-xs text-[#5B616E] font-normal">started {new Date(exp.created_at).toLocaleDateString()}</span>
                  </CardTitle>
                  <Badge variant="outline" className="text-[10px]">{totalImps} impressions</Badge>
                </CardHeader>
                <CardContent>
                  <table className="w-full text-sm">
                    <thead className="text-[10px] uppercase text-[#5B616E]">
                      <tr>
                        <th className="text-left py-1">Variant</th>
                        <th className="text-left py-1">Headline</th>
                        <th className="text-right py-1">Imps</th>
                        <th className="text-right py-1">Clicks</th>
                        <th className="text-right py-1">CTR</th>
                      </tr>
                    </thead>
                    <tbody>
                      {variants.map((v) => (
                        <tr key={v.id} className={v.id === winnerId ? 'bg-[#1F7A5A]/05' : ''}>
                          <td className="py-1.5 pr-2 font-mono text-xs">
                            {v.id}
                            {v.id === winnerId && <Badge className="ml-2 text-[10px] bg-[#1F7A5A] text-white">Winner</Badge>}
                          </td>
                          <td className="py-1.5 pr-2">{v.headline}</td>
                          <td className="py-1.5 text-right">{v.impressions || 0}</td>
                          <td className="py-1.5 text-right">{v.clicks || 0}</td>
                          <td className="py-1.5 text-right font-medium">{(v.ctr || 0).toFixed(2)}%</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </CardContent>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}
